import listFields from './list';
import productFields from './product';
import reviewFields from './review';
import adminUserFields from './adminUser';
import adminArticleFields from './adminArticle';

export default {
    list: function( data ) {
        var patchObject = Object.constrain( data, listFields );
        return patchObject;
    },
    product: function( data ) {
        var patchObject = Object.constrain( data, productFields );
        return patchObject;
    },
    review: function( data ) {
        var patchObject = Object.constrain( data, reviewFields );
        return patchObject;
    },
    admin: {
        user: function( data ) {
            var patchObject = Object.constrain( data, adminUserFields );
            return patchObject;
        },
        article: function( data ) {
            var patchObject = Object.constrain( data, adminArticleFields );
            return patchObject;
        },
    },
};
